$(document).ready(function () {
	//Hide element when smaller than 1025
	if ($(window).width() < 1200) {
		$(".nav-primary-menu").fadeIn(function () {
			$(".nav-primary-menu").css({
				display: "flex",
			});
		});
	}
	try {
		if ($(window).width() > 1200.1) {
			fullPageInit();
		}
		aosInit();
	} catch (error) {}

	setBackground();
	swiperInit();
	toggleFunc();
	tabFunc();
	mappingFunc();
	backToTop();
	stickyNav();
	counterJs();
	if ($(window).width() > 1200.1) {
		mouseFnc();
	}
});
$(window).resize(() => {
	$(this).width() < 1024.1 && mappingFunc();
});

$("body").on("click", ".dealer-list .item", function (e) {
	let map = $(this).attr("data-map");
	$(".dealer-list .item").removeClass("is-active");
	$(this).addClass("is-active");
	$(".map-wrapper iframe").attr("src", map);
});
window.onload = function () {
	// let's go!
	if ($(".dealer-list").length) {
		$(".dealer-list .item:first-child").trigger("click");
	}
};

function mouseFnc() {
	const item = $(".card-option");
	item.on("mouseenter", function () {
		$(".card-option").removeClass("active");
		$(this).toggleClass("active");
	});
}

function backToTop() {
	try {
		if ($("body").hasClass("homepage")) {
			if ($(window).width() > 1200.1) {
				$(".back-to-top").on("click", function (e) {
					fullpage_api.moveTo(1);
				});
			}
			if ($(window).width() < 1200.1) {
				let btn = $(".back-to-top");
				btn.on("click", function (e) {
					e.preventDefault();
					$("html, body").animate(
						{
							scrollTop: 0,
						},
						"300"
					);
				});
			}
		} else {
			let btn = $(".back-to-top");
			btn.on("click", function (e) {
				e.preventDefault();
				$("html, body").animate(
					{
						scrollTop: 0,
					},
					"300"
				);
			});
		}
	} catch (error) {}
}

function aosInit() {
	AOS.init({
		// Global settings:

		disable: window.innerWidth < 1200,
		startEvent: "load", // name of the event dispatched on the document, that AOS should initialize on
		initClassName: "aos-init", // class applied after initialization
		animatedClassName: "aos-animate", // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		debounceDelay: 20, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 0, // the delay on throttle used while scrolling the page (advanced)
		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 120, // offset (in px) from the original trigger point
		delay: 120, // values from 0 to 3000, with step 50ms
		duration: 500, // values from 0 to 3000, with step 50ms
		easing: "ease-in-out-back", // default easing for AOS animations
		once: true,
		mirror: true, // whether elements should animate out while scrolling past them
		anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
	});
}
function fullPageInit() {
	try {
		var myFullpage = new fullpage("#fullpage", {
			licenseKey: "A3DA879C-B1254377-8A906973-AAE812EA",
			//Navigation
			bigSectionsDestination: null,
			menu: "#header,#menu-parallax,#fixed-side-nav,#link-to-site",
			lockAnchors: false,
			fixedElements:
				"#header,#menu-parallax,#fixed-side-nav,#link-to-site",
			anchors: [
				"firstPage",
				"secondPage",
				"thirdPage",
				"fourthPage",
				"fifthPage",
				"sixthPage",
				"seventhPage",
				"lastPage",
			],
			navigationTooltips: [
				"firstPage",
				"secondPage",
				"thirdPage",
				"fourthPage",
				"fifthPage",
				"sixthPage",
				"seventhPage",
				"lastPage",
			],
			slidesNavigation: true,
			slidesNavPosition: "bottom",
			showActiveTooltip: true,
			//Scrolling
			css3: true,
			offsetSections: true,
			scrollingSpeed: 700,
			autoScrolling: true,
			fitToSection: false,
			paddingTop: "100px",
			fitToSectionDelay: 600,
			scrollBar: false,
			easing: "easeInOutCubic",
			easingcss3: "ease",
			loopBottom: false,
			loopTop: false,
			loopHorizontal: true,
			continuousHorizontal: true,
			scrollHorizontally: true,
			continuousVertical: false,
			scrollOverflow: false,
			touchSensitivity: 15,
			normalScrollElementTouchThreshold: 5,
			//Accessibility
			keyboardScrolling: true,
			animateAnchor: true,
			recordHistory: true,
			//Design
			controlArrows: true,
			verticalCentered: true,
			resize: false,
			responsiveWidth: 0,
			responsiveHeight: 0,
			//Custom selectors
			sectionSelector: "section",
			dragAndMove: true,
			onLeave: function () {
				$("section [data-aos]").removeClass("aos-animate");
			},
			onSlideLeave: function () {
				$("section [data-aos]").removeClass("aos-animate");
			},
			afterSlideLoad: function () {
				$("section.active [data-aos]").addClass("aos-animate");
			},
			afterLoad: function () {
				$("section.active [data-aos]").addClass("aos-animate");
			},
		});
	} catch (error) {}
}

function toggleFunc() {
	$(".card-option").click(function () {
		$(".card-option").removeClass("active");
		$(this).addClass("active");
	});

	document
		.querySelector(".menu-toggle")
		.addEventListener("click", function (event) {
			document
				.querySelector(".mobile-nav-wrap")
				.classList.toggle("is-open");
			document.querySelector("body").classList.toggle("overlay-bg");
			document.querySelector(".hamburger").classList.toggle("is-active");
		});
	document
		.querySelector(".search-toggle")
		.addEventListener("click", function (event) {
			document.querySelector(".searchbox").classList.toggle("open");
		});
	document.addEventListener("click", function (event) {
		if (
			!event.target.closest(".search-toggle") &&
			!event.target.closest(".searchbox")
		) {
			document.querySelector(".searchbox").classList.remove("open");
		}
	});
	document.addEventListener("click", function (event) {
		if (
			!event.target.closest(".mobile-nav-wrap") &&
			!event.target.closest(".menu-toggle")
		) {
			document
				.querySelector(".mobile-nav-wrap")
				.classList.remove("is-open");
			document.querySelector("body").classList.remove("overlay-bg");
		}
	});
	if ($(window).width() < 1200) {
		$(".drop-down .title em").on("click", function () {
			if ($(this).parents(".drop-down").hasClass("is-open")) {
				$(".drop-down .nav-sub").slideUp();
				$(".drop-down").removeClass("is-open");
			} else {
				$(".drop-down .nav-sub").slideUp();
				$(".drop-down").removeClass("is-open");
				$(this).parent().next().slideDown();
				$(this).parents(".drop-down").addClass("is-open");
			}
		});
	}
}

function swiperInit() {
	var homeClient = new Swiper(".home-project-swiper  .swiper", {
		// Optional parameters
		// centeredSlides: true,
		spaceBetween: 30,
		speed: 500,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		loop: true,
		preventInteractionOnTransition: true,
		slideToClickedSlide: true,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 2,
			},
		},
		navigation: {
			nextEl: ".home-project-swiper  .nav-next",
			prevEl: ".home-project-swiper  .nav-prev",
		},
	});

	try {
		homeClient.slideTo(1);
		homeClient.autoplay.start();
	} catch (error) {}

	$(".single-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("single-instance-" + index);
		$this
			.parent()
			.find(".nav-prev")
			.addClass("btn-prev-single-" + index);
		$this
			.parent()
			.find(".nav-next")
			.addClass("btn-next-single-" + index);
		$this
			.parent()
			.find(".swiper-pagination")
			.addClass("pagination-instance-" + index);
		var swiper = new Swiper(".single-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			slidesPerView: 1,
			navigation: {
				nextEl: ".btn-next-single-" + index,
				prevEl: ".btn-prev-single-" + index,
			},
			pagination: {
				el: ".pagination-instance-" + index,
				type: "bullets",
				clickable: true,
			},
		});
	});
	var primarySwiper = new Swiper(".primary-banner .swiper", {
		// Optional parameters
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},

		pagination: {
			el: ".primary-banner  .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});
	$(".trinity-swiper .swiper").each(function (index, element) {
		const $element = $(element);
		const parent = $element.parent();
		const prev = parent.find(".nav-prev");
		const next = parent.find(".nav-next");
		const options = {
			speed: 750,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: next,
				prevEl: prev,
			},
		};
		$element.addClass(`t-${index}`);
		prev.addClass(`bp-${index}`);
		next.addClass(`bn-${index}`);
		new Swiper(`.t-${index}`, {
			...options,
			navigation: {
				...options.navigation,
				nextEl: `.bn-${index}`,
				prevEl: `.bp-${index}`,
			},
		});
	});

	var projectThumbs = new Swiper(".project-swiper-thumb  .swiper", {
		spaceBetween: 20,
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
		},
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var projectMain = new Swiper(".project-swiper-main .swiper", {
		spaceBetween: 16,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1.25,
			},
		},
		centeredSlides: true,
		lazy: {
			loadPrevNext: true,
		},
		autoplay: {
			delay: 3000,
		},
		speed: 750,
		loop: false,
		thumbs: {
			swiper: projectThumbs,
		},
		navigation: {
			nextEl: ".project-swiper-thumb .nav-next",
			prevEl: ".project-swiper-thumb .nav-prev",
		},
	});

	try {
		projectMain.slideTo(1), projectMain.autoplay.start();
	} catch (e) {}

	var swiperGrid = new Swiper(".grid-swiper .swiper", {
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		speed: 750,
		spaceBetween: 30,
		observer: true,
		observeParents: true,
		breakpoints: {
			200: {
				slidesPerView: 1,
			},
			540: {
				slidesPerView: 2,
			},
			769: {
				slidesPerView: 3,
			},
			1280: {
				spaceBetween: 40,
				slidesPerView: 3,
				grid: {
					rows: 2,
				},
			},
		},
		navigation: {
			nextEl: ".grid-swiper .nav-next",
			prevEl: ".grid-swiper .nav-prev",
		},
	});

	var homePartner = new Swiper(".home-partner-swiper .swiper", {
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		speed: 750,
		observer: true,
		spaceBetween: 30,
		observeParents: true,

		breakpoints: {
			200: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			576: {
				slidesPerView: 3,
			},
			769: {
				slidesPerView: 4,
			},
			1200: {
				slidesPerView: 6,
			},
		},
		navigation: {
			nextEl: ".nav-next",
			prevEl: ".nav-prev",
		},
	});

	$(".about-partner .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("partner-instance-" + index);
		$this
			.parent()
			.find(".nav-prev")
			.addClass("btn-prev-tri-" + index);
		$this
			.parent()
			.find(".nav-next")
			.addClass("btn-next-tri-" + index);

		var swiper = new Swiper(".partner-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 16,
			observeParents: true,

			breakpoints: {
				200: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 5,
				},
			},
			navigation: {
				nextEl: ".nav-next",
				prevEl: ".nav-prev",
			},
		});
	});
}

//Tab Func
function tabFunc() {
	$(".tab-nav li a").on("click", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$(this).parent().addClass("active");
		var display = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}
// Side
function setBackground() {
	const elements = document.querySelectorAll("[setBackground]");
	elements.forEach((element) => {
		element.style.cssText = `
		background-image: url(${element.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
}

function stickyNav() {
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: $("header").outerHeight(),
		});
	}

	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".about-section-wrap .about-section-id").each(function (i) {
				if (
					$(this).position().top -
						$(".sticky-nav").outerHeight() -
						$("header").outerHeight() -
						1 <=
					scrollDistance
				) {
					$(".sticky-nav li.active").removeClass("active");
					$(".sticky-nav li").eq(i).addClass("active");
				}
			});
		})
		.scroll();
	$(".sticky-nav a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});
}

function counterJs() {
	const counterUp = window.counterUp.default;

	const callback = (entries) => {
		entries.forEach((entry) => {
			const el = entry.target;
			if (entry.isIntersecting && !el.classList.contains("is-visible")) {
				counterUp(el, {
					duration: 2000,
					delay: 50,
				});
				el.classList.add("is-visible");
			}
		});
	};

	const IO = new IntersectionObserver(callback, { threshold: 1 });

	const el = document.querySelectorAll(".counter");

	el.forEach((counter) => {
		IO.observe(counter);
	});
}
function mappingFunc() {
	new MappingListener({
		selector: ".nav-primary-menu",
		mobileWrapper: ".mobile-nav-wrap",
		mobileMethod: "appendTo",
		desktopWrapper: ".language-wrapper ",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();
}
